// Module
var code = `<div class="jumbotron-page playlist-compose">

  <div class="jumbotron-toolbar playlist-compose-toolbar" ng-style="{ 'border-bottom-color': \$ctrl.scene.color }">
    <button type="button" class="btn btn-sm btn-outline-primary" ng-click="\$ctrl.back()"
      title="Back to the playlist">
      <i class="fas fa-arrow-left" aria-hidden="true"></i> {{ \$ctrl.scene.name }}
    </button>
    <div class="jumbotron-page-heading">
      <span class="jumbotron-title">Compose</span>
      <span class="jumbotron-subtitle playlist-compose-subtitle">{{ \$ctrl.playlist.name }} · {{ \$ctrl.view.itemCount }} items ·
        {{ \$ctrl.view.totalMs | duration }}<span ng-if="\$ctrl.view.loops"> · loops {{ \$ctrl.view.loops.times }}
          times over {{ \$ctrl.view.loops.range }}</span></span>
    </div>
    <div class="playlist-compose-actions">
      <button type="button" class="btn btn-sm btn-outline-secondary" ng-class="{ active: \$ctrl.helpOpen }"
        ng-click="\$ctrl.toggleHelp()" title="How Compose and labels work">
        <i class="fas fa-circle-question" aria-hidden="true"></i> How it works
      </button>
      <button type="button" class="btn btn-sm btn-outline-primary" ng-click="\$ctrl.undo()"
        ng-disabled="!\$ctrl.view.canUndo" title="Back to the previous order">
        <i class="fas fa-rotate-left" aria-hidden="true"></i> Undo
      </button>
      <button type="button" class="btn btn-sm btn-outline-primary" ng-click="\$ctrl.regenerate()"
        ng-disabled="\$ctrl.view.itemCount < 2" title="A new order for the same items">
        <i class="fas fa-rotate" aria-hidden="true"></i> Regenerate
      </button>
      <button type="button" class="btn btn-sm btn-outline-primary" ng-click="\$ctrl.unpinAll()"
        title="Release every pinned slot">
        <i class="fas fa-thumbtack-slash" aria-hidden="true"></i> Unpin all
      </button>
      <button type="button" class="btn btn-sm btn-outline-primary" ng-class="{ active: \$ctrl.takeoverOpen }"
        ng-click="\$ctrl.takeoverOpen ? \$ctrl.closeTakeover() : \$ctrl.openTakeover()"
        ng-disabled="\$ctrl.view.itemCount === 0 || \$ctrl.creating"
        title="Copy this list as a takeover for one act">
        <i class="fas fa-copy" aria-hidden="true"></i> Copy as takeover
      </button>
      <button type="button" class="btn btn-sm btn-primary" ng-click="\$ctrl.save()"
        ng-disabled="\$ctrl.saving || !\$ctrl.view.canSave"
        title="{{ \$ctrl.view.canSave ? 'Write the order to the playlist' : 'Remove the rows that cannot play first' }}">
        <i class="fas fa-fw" aria-hidden="true"
          ng-class="\$ctrl.saving ? 'fa-spinner fa-spin' : 'fa-check'"></i> Save
      </button>
    </div>
  </div>

  <div class="playlist-compose-columns">

    <div class="jumbotron-surface playlist-compose-recipe">
      <div class="jumbotron-panel-head">
        <span class="jumbotron-heading">Recipe</span>
        <span class="playlist-compose-count">{{ \$ctrl.view.mediaCount }} media · {{ \$ctrl.view.itemCount }} items ·
          {{ \$ctrl.view.totalMs | duration }}</span>
      </div>

      <takeover-panel ng-if="\$ctrl.takeoverOpen" source="\$ctrl.state" scene="\$ctrl.scene"
        base-name="\$ctrl.playlist.name" revision="\$ctrl.revision" on-busy="\$ctrl.takeoverBusy(\$busy)"
        on-close="\$ctrl.closeTakeover()" on-created="\$ctrl.takeoverCreated(\$collectionId)">
      </takeover-panel>

      <div class="playlist-compose-filters">
        <span class="jumbotron-field-label">Add candidates by label</span>
        <div class="playlist-compose-chips" title="A label that is on adds its media to the recipe as candidates. Kind labels first, then days and scenes.">
          <button type="button" class="jumbotron-chip playlist-compose-chip is-all" ng-class="{ 'is-off': !\$ctrl.view.allMedia }"
            ng-click="\$ctrl.toggleAllMedia()" title="Offer every media in the library">All media</button>
          <button type="button" class="jumbotron-chip playlist-compose-chip" ng-repeat="label in \$ctrl.view.labels track by label.id"
            ng-class="{ 'is-off': !label.on }" ng-style="{ 'border-color': label.colour, color: label.colour }"
            title="{{ label.count }} media not in the list yet"
            ng-click="\$ctrl.toggleLabel(label.id)">{{ label.name }} <span class="playlist-compose-chip-count">{{ label.count }}</span></button>
        </div>
        <div class="playlist-compose-filter-row">
          <label class="playlist-compose-toggle">
            <input type="checkbox" ng-model="\$ctrl.hideUnused" ng-change="\$ctrl.refresh()"> Hide unused
          </label>
          <input type="search" class="form-control form-control-sm playlist-compose-search" placeholder="Search name"
            aria-label="Search name" ng-model="\$ctrl.search" ng-change="\$ctrl.refresh()"
            ng-model-options="{ debounce: 250 }">
        </div>
      </div>

      <div class="jumbotron-scroll playlist-compose-scroll">
        <div class="jumbotron-note playlist-compose-empty" ng-if="\$ctrl.view.itemCount === 0 && \$ctrl.view.groups.length === 0">
          This playlist is empty. Add media from the library on the scene page, or turn on a label or All media
          here and press plus.
        </div>
        <div ng-repeat="group in \$ctrl.view.groups track by group.name">
          <div class="playlist-compose-group" ng-style="{ 'border-left-color': group.colour }"
            title="{{ group.name }}: {{ group.count }} items, {{ group.ms | duration }} of the {{ \$ctrl.view.totalMs | duration }} loop">
            <span class="jumbotron-dot-big playlist-compose-dot" ng-style="{ 'background-color': group.colour }"></span>
            <span class="jumbotron-kind-label">{{ group.name }}</span>
            <span class="jumbotron-note">×{{ group.count }}</span>
            <div class="jumbotron-bar-track playlist-compose-bar" title="Share of the loop">
              <div class="jumbotron-bar-fill"
                ng-style="{ width: (group.fraction * 100) + '%', 'background-color': group.colour }"></div>
            </div>
            <span class="jumbotron-number-cell playlist-compose-group-share">{{ group.ms | duration }} of
              {{ \$ctrl.view.totalMs | duration }}</span>
          </div>
          <div class="playlist-compose-line" ng-repeat="line in group.lines track by line.key"
            data-line-key="{{ ::line.key }}"
            ng-class="{ 'is-zero': line.count === 0, 'is-fresh': line.fresh, 'jumbotron-selected': \$ctrl.litKey === line.key }"
            ng-mouseenter="\$ctrl.light(line.key)" ng-mouseleave="\$ctrl.unlight()">
            <div class="playlist-compose-dots">
              <span class="jumbotron-dot playlist-compose-dot" ng-repeat="label in line.media.labels track by label.id"
                ng-style="{ 'background-color': label.color || 'var(--jumbotron-primary)' }" title="{{ label.name }}"></span>
            </div>
            <img class="playlist-compose-thumb" ng-if="line.media.thumbnailUrl" ng-src="{{ line.media.thumbnailUrl }}"
              alt="" draggable="false">
            <div class="playlist-compose-name" title="{{ line.media.name }}">
              <i class="jumbotron-note fas" aria-hidden="true" ng-if="!line.media.thumbnailUrl"
                ng-class="\$ctrl.typeIcon(line.media.mediaType)"></i>
              <span class="playlist-compose-name-text">{{ line.media.name }}</span>
              <i class="jumbotron-note fas fa-triangle-exclamation playlist-compose-warn" ng-if="!line.available" aria-hidden="true"
                title="{{ line.blockerNote }}"></i>
            </div>
            <div class="jumbotron-note jumbotron-number-cell playlist-compose-sec">{{ line.durationMs | duration }}</div>
            <compose-stepper value="line.count" min="0" disabled="!line.available"
              disabled-note="{{ line.blockerNote }}" on-step="\$ctrl.step(line, \$delta)"></compose-stepper>
            <compose-stepper class="playlist-compose-posts" ng-if="line.posts !== null" value="line.posts" min="1"
              max="line.maxPosts" label="posts" disabled="line.count === 0"
              disabled-note="Add it first, then set the posts"
              on-step="\$ctrl.stepPosts(line, \$delta)"></compose-stepper>
            <div class="jumbotron-note playlist-compose-sentence" ng-if="line.count > 0">every
              {{ line.outcome.everyMs | duration }} · {{ \$ctrl.perHour(line.outcome) }} an hour</div>
            <div class="jumbotron-note playlist-compose-sentence" ng-if="line.count === 0">not in the list</div>
          </div>
        </div>
      </div>

      <div class="jumbotron-note playlist-compose-rules">
        Rules: <span ng-repeat="rule in \$ctrl.view.rules track by rule">{{ rule }}<span ng-if="!\$last"> · </span></span>
      </div>
    </div>

    <div class="jumbotron-surface playlist-compose-sequence">
      <div class="jumbotron-panel-head">
        <span class="jumbotron-heading">Sequence</span>
        <span class="playlist-compose-count"><span ng-if="\$ctrl.view.seed === null">Stored order</span><span
            ng-if="\$ctrl.view.seed !== null">Seed {{ \$ctrl.view.seed }}</span><span
            ng-if="\$ctrl.view.closestRepeat !== null"> · closest repeat {{ \$ctrl.view.closestRepeat }} slots
            apart</span></span>
      </div>

      <div class="playlist-compose-notes">
        <div class="jumbotron-note-box is-ok"
          ng-if="\$ctrl.view.blockers.length === 0 && \$ctrl.view.sentences.length === 0 && \$ctrl.view.unevenWaits.length === 0">Every rule holds.</div>
        <div class="jumbotron-note-box is-bad" ng-if="\$ctrl.view.blockers.length > 0">
          <div ng-repeat="blocker in \$ctrl.view.blockers track by \$index">{{ blocker }}</div>
        </div>
        <div class="jumbotron-note-box playlist-compose-note is-hint" ng-if="\$ctrl.view.unevenWaits.length > 0">
          <span ng-if="\$ctrl.view.blockers.length === 0 && \$ctrl.view.sentences.length === 0">Every rule holds, but</span>
          <span ng-repeat="item in \$ctrl.view.unevenWaits track by item.name">{{ item.name }} comes back after
            {{ item.shortestMs | duration }} to {{ item.longestMs | duration }}.<span ng-if="!\$last"> </span></span>
          Regenerate for even waits.
        </div>
        <div class="jumbotron-note-box is-warn" ng-if="\$ctrl.view.sentences.length > 0">
          <div ng-repeat="sentence in \$ctrl.view.sentences track by \$index">{{ sentence }}</div>
        </div>
      </div>

      <div class="playlist-compose-strip-box">
        <div class="playlist-compose-strip">
          <div class="playlist-compose-cell" ng-repeat="row in \$ctrl.view.rows track by row.id"
            ng-class="{ 'is-pinned': row.pinned, 'is-lit': \$ctrl.litKey === row.key,
              'is-dim': \$ctrl.litKey && \$ctrl.litKey !== row.key }"
            ng-style="{ 'flex-grow': row.durationMs, 'background-color': row.media.colour }"
            title="{{ row.slot + 1 }} · {{ row.media.name }} · {{ row.durationMs | duration }}">
            <i class="fas fa-thumbtack playlist-compose-pinmark" ng-if="row.pinned" aria-hidden="true"></i>
          </div>
        </div>
        <div class="playlist-compose-ticks">
          <span class="playlist-compose-tick-start">0:00</span>
          <span class="playlist-compose-tick-end">{{ \$ctrl.view.totalMs | duration }}</span>
        </div>
        <div class="playlist-compose-legend">
          <span class="jumbotron-note playlist-compose-legend-item" ng-repeat="share in \$ctrl.view.shares track by share.name">
            <span class="jumbotron-dot playlist-compose-dot" ng-style="{ 'background-color': share.colour }"></span>{{ share.name }}
          </span>
        </div>
      </div>

      <div class="jumbotron-scroll playlist-compose-scroll playlist-compose-sequence-scroll"
        drag-drop-list="\$ctrl.dropTarget" drag-drop-list-count="\$ctrl.view.rows.length">
        <div class="playlist-compose-row" ng-repeat="row in \$ctrl.view.rows track by row.id" draggable="true"
          data-row-id="{{ ::row.id }}"
          data-drag-slot drag-drop-row="\$ctrl.dropTarget" drag-drop-row-id="row.id"
          drag-drop-row-index="row.slot"
          ng-class="{
            'is-pinned': row.pinned,
            'is-blocked': !row.available,
            'jumbotron-selected': \$ctrl.litKey === row.key
          }"
          ng-mouseenter="\$ctrl.light(row.key)" ng-mouseleave="\$ctrl.unlight()">
          <div class="playlist-compose-index">
            <i class="jumbotron-note fas fa-grip-vertical playlist-compose-grip" aria-hidden="true"></i>
            <strong>{{ row.slot + 1 }}</strong>
            <i class="jumbotron-note fas" aria-hidden="true" ng-class="\$ctrl.typeIcon(row.mediaType)"></i>
          </div>
          <div class="playlist-compose-dots">
            <span class="jumbotron-dot playlist-compose-dot" ng-repeat="label in row.media.labels track by label.id"
              ng-style="{ 'background-color': label.color || 'var(--jumbotron-primary)' }" title="{{ label.name }}"></span>
          </div>
          <div class="playlist-compose-name" title="{{ row.media.name }}">
            <span class="playlist-compose-name-text">{{ row.media.name }}</span>
            <i class="jumbotron-note fas fa-triangle-exclamation playlist-compose-warn" ng-if="!row.available" aria-hidden="true"
              title="{{ row.blockerNote }}"></i>
          </div>
          <div class="jumbotron-note jumbotron-number-cell playlist-compose-sec">{{ row.durationMs | duration }}</div>
          <button type="button" class="playlist-compose-pin" ng-click="\$ctrl.togglePin(row.slot)"
            ng-class="{ 'is-on': row.pinned }"
            title="{{ row.pinned ? 'Release this slot' : 'Keep this row in this slot' }}"
            aria-label="Pin this slot">
            <i class="fas fa-thumbtack" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>

  </div>
  <dialog class="jumbotron-dialog playlist-compose-dialog" jumbotron-dialog="\$ctrl.helpOpen"
    jumbotron-dialog-close="\$ctrl.closeHelp()" aria-labelledby="playlist-compose-help-heading">
    <div class="jumbotron-panel-head">
      <h2 class="jumbotron-heading" id="playlist-compose-help-heading">How Compose works</h2>
      <button type="button" class="btn-close" ng-click="\$ctrl.toggleHelp()" aria-label="Close"></button>
    </div>
    <div class="jumbotron-dialog-body">
      <ul>
        <li><strong>Recipe</strong> is what and how much. One line per media, with a count. Change a count with
          plus and minus, and the outcome beside it tells you how often it will be on screen.</li>
        <li><strong>Sequence</strong> is in which order. The order is generated from the counts. Press Regenerate
          for another one. Drag a row to a slot to pin it there; pinned rows stay when the rest is regenerated.</li>
        <li>The rules are sentences, not blockers. The same media stays at least four slots and a minute apart, two of the same
          kind are never neighbours, and a long film is followed by something short. When a count cannot keep a
          rule, the sentence says so. The rules are fixed; the line under the recipe shows them.</li>
        <li>Undo takes you back one step, for anything you did since you opened Compose.</li>
        <li>On a social line, posts is how many posts play each time; each post takes ten seconds.</li>
        <li>Nothing is saved until you press Save. Back without Save leaves the playlist as it was.</li>
      </ul>
      <span class="jumbotron-field-label">Copy as takeover</span>
      <ul>
        <li>Before a concert the screen shows the day's list with the act's bumper in it. Building that list by
          hand is copy, paste, add the bumper five times and drag it into place, for every act. Copy as takeover
          does it in one step.</li>
        <li>Pick the bumper and how often it plays. The copy is made and spread for you, with the bumper on the
          first slot. Your pins are kept; the other rows are spread again. The bumper cannot be forgotten.</li>
        <li>Give a start and an end and the copy is scheduled at once as a Takeover. Leave them empty and
          schedule it in the calendar later.</li>
      </ul>
      <span class="jumbotron-field-label">Labels</span>
      <ul>
        <li>Every media should have one day label, or one for all days, and exactly one kind label such as
          Reklame, Orange TV or Steps. Add a scene label only when the media must not be shown on another scene.</li>
        <li>The kind label decides the group, the colour in the strip and the rule that keeps two of a kind apart.
          A media without a kind label lands in "No kind label", and that rule cannot help it.</li>
        <li>Turn on a label chip to see its media as candidates at count 0. The number on the chip is how many
          media the click adds, so a media the list already holds is not counted. All media shows the whole
          library. Hide unused hides the candidates again.</li>
        <li>A new line is lit for a moment and its group goes to the top of the list. A line that the search
          or Hide unused takes out of the list cannot be lit.</li>
        <li>Right-click a row to add or remove a label. A label is saved at once; the order is saved with Save.</li>
      </ul>
      <div class="playlist-compose-help-tools">
        <span>Does the order look wrong? Show the data behind it and send it to the developers.</span>
        <button type="button" class="btn btn-sm btn-outline-secondary" ng-click="\$ctrl.toggleDebug()">
          <i class="fas fa-bug" aria-hidden="true"></i> {{ \$ctrl.debug ? 'Hide debug data' : 'Show debug data' }}
        </button>
      </div>

      <div class="playlist-compose-debug" ng-if="\$ctrl.debug">
        <div class="playlist-compose-debug-head">
          <span class="jumbotron-field-label">Debug</span>
          <button type="button" class="btn btn-sm btn-outline-secondary" ng-click="\$ctrl.copyDebug()"
            title="Put the data on the clipboard">
            <i class="fas fa-copy" aria-hidden="true"></i> Copy debug
          </button>
        </div>
        <pre class="playlist-compose-debug-text">{{ \$ctrl.view.debug }}</pre>
      </div>
    </div>
  </dialog>

</div>
`;
// Exports
export default code;